import { LandingPageTemplate } from "./components/landing-page-template";
import props from "./brand";

function App() {
  return <LandingPageTemplate {...props} />;
}

export default App;
